module.exports = __webpack_public_path__ + "static/hackathon-fb-795903d15f47cb24734f49df3051ce73.png";